export default __webpack_public_path__ + "static/media/gameDealImage3.2ecf54c1.png";